module.exports = __webpack_public_path__ + "static/img/zizhi2_03.3c4b87a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutOur/intelligence/zizhi2_03.jpg
// module id = MUqW
// module chunks = 0